<template>
  <CBox
    :class="{ 'refund-new--audit-flow': isAuditFlow }"
    :bg="['none', '#F6F6F9']"
    minHeight="100vh"
    width="100vw"
    position="sticky"
  >
    <Header :titleLabel="pageTitle" />
    <omint-slider>
      <router-view />
    </omint-slider>
    <Footer v-if="!isAuditFlow" />
  </CBox>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    isAuditFlow() {
      return this.$route.path === "/refund-new/audit-explanation" || this.$route.path.startsWith("/refund-new/audit");
    },
    pageTitle() {
      if (this.isAuditFlow) return "Auditoria de reembolso";
      return this.$route.name === "refund.new.statement" ? "Extrato de reembolsos" : "Reembolsos";
    }
  }
};
</script>

<style>
.refund-new--audit-flow {
  background: #ffffff !important;
}

.refund-new--audit-flow .header-page {
  height: 48px;
}

.refund-new--audit-flow .header-grid.omt-grid {
  height: 48px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.refund-new--audit-flow .header-page + div {
  height: 48px;
}

.refund-new--audit-flow .refund-audit-page.omt-grid {
  padding-top: 16px;
  padding-bottom: 24px;
}

.refund-new--audit-flow .refund-audit-page h1 {
  line-height: 32px !important;
}

.refund-new--audit-flow .refund-audit-page h2 {
  line-height: 20px !important;
}

.refund-new--audit-flow .refund-audit-page h3 {
  line-height: 19px !important;
}

@media screen and (min-width: 1024px) {
  .refund-new--audit-flow .header-page {
    height: 56px;
  }

  .refund-new--audit-flow .header-page + div {
    height: 56px;
  }

  .refund-new--audit-flow .refund-audit-page.omt-grid {
    margin-top: 0;
  }
}
</style>
